// extracted by mini-css-extract-plugin
export default {"aaPRSItem":"aaPRSItem_aaPRSItem__lTzSg","aaPRSItem__icon":"aaPRSItem_aaPRSItem__icon__VkNiY","aaPRSItem__arrow":"aaPRSItem_aaPRSItem__arrow__Bfwds"};